import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guest: "",
  extendStayStatus: "",
  lateCheckOutStatus: "",
  vehicleMake: "",
  licensePlate: "",
  specialRequests: "",
  guestSignature: null,
  idProof: "",
};

const guestSlice = createSlice({
  name: "guest",
  initialState: initialState,
  reducers: {
    setGuest: (state, action) => {
      state.guest = action.payload;
    },
    addExtendStayStatus: (state, action) => {
      state.extendStayStatus = action.payload;
    },
    setLateCheckOutStatus: (state, action) => {
      state.lateCheckOutStatus = action.payload;
    },
    setVehicleMake: (state, action) => {
      state.vehicleMake = action.payload;
    },
    setLicensePlate: (state, action) => {
      state.licensePlate = action.payload;
    },
    setSpecialRequests: (state, action) => {
      state.specialRequests = action.payload;
    },
    setGuestSignature: (state, action) => {
      state.guestSignature = action.payload;
    },
    setIdProof: (state, action) => {
      state.idProof = action.payload;
    },
  },
});

export const {
  setGuest,
  addExtendStayStatus,
  setLateCheckOutStatus,
  setVehicleMake,
  setLicensePlate,
  setSpecialRequests,
  a,
  setIdProof,
} = guestSlice.actions;
export default guestSlice.reducer;
